<style lang="less">
	#editor{
		.editorContainer{
			margin-bottom: 20px;
			// border: 1px solid #efefef !important;
			min-height: 30px;
			// &.focus {
			// 	-webkit-box-shadow: 0px 0px 6px 2px #efefef;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
			// 	-moz-box-shadow:    0px 0px 6px 2px #efefef;  /* Firefox 3.5 - 3.6 */
			// 	box-shadow:         0px 0px 6px 2px #efefef;  
			// }
			.editorElement{
				border: 2px solid #efefef;
				min-height: 40px;
			}	
			.bordered{
				border: 1px solid #efefef;
			}		
		}
		#pop-out-menu{
			position: absolute;
			right: 100px;
			z-index: 1;
		}
		.focusButton{
			position: absolute;
			right: -5px;
			top: -5px;
			height: 20px;
			width: 20px;
		}	
	}
</style>
<template>
	<v-sheet flat class="pa-3" id="editor">
		<v-tabs v-model="tab" right>
			<v-tab >edit</v-tab>
			<v-tab >preview</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab">
			<v-tab-item >
				<div class="editorContainer" ref="editorContainer">
					<template  v-for="(element, i) in elements" >
						<EditorElement :element="element" :focus="focus" v-on:delete="deleteElement" v-on:focus="(f) => {focus = f}" :key="i"></EditorElement>
					</template>
				</div>
				<v-btn color="green" dark absolute right fab @click="menu = !menu" class="mt-7" >
					<v-icon v-if="menu">mdi-close</v-icon>
					<v-icon v-else>mdi-plus</v-icon>
				</v-btn>	
				<v-card v-if="menu" id="pop-out-menu">
					<v-list>
						<v-list-item-group v-for="(item, i) in allowedElements" :key="item.key">
							<v-list-item @click="newElement(item)">
								<v-list-item-avatar :color="colors[i]">
									<v-icon color="white" v-text="item.icon"></v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title>{{item.name}}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>	
					</v-list>
				</v-card>			
			</v-tab-item>
			<v-tab-item>
				<v-sheet>
					<DisplayEditorPost :elements="elements"></DisplayEditorPost>
				</v-sheet>
			</v-tab-item>
		</v-tabs-items>
	</v-sheet>
</template>




<script type="text/javascript">
	import Vuex from "vuex";
	// import Row from "../tools/TextEditor/Row.vue"
	export default {
		name: "TextEditor",
		props: ["elements"],
		data: () =>{
			return {
				tab: 0,
				focus: false,
				menu: false,
				allElements: [
					{
						name: "Card",
						key: "card",
						icon: "mdi-card-bulleted-outline",
						accepts: ["row", "card", "text", "html", "hr", "button"],
						component: "EditorCard",
						start: true,
						elements: [],
						title: "",
						text: "",
						attrs: {
							flat: false, 
							colors: {
								background: "white",
								text: "black",
								title: "black",
							},
							padding: "pa-4",
							margin: "ma-0",
							width: "100%",
							typography: {
								text: "text",
								title: "text"
							},
							alignment: {
								text: "text-left",
								title: "text-left"
							},			
						}
					},
					{
						name: "Row",
						key: "row",
						icon: "mdi-table-row",
						accepts: ["column"],
						component: "EditorRow",
						elements: [],
						start: true,
						attrs: {
							class: "pa-4",
							padding: "pa-4",
							margin: "ma-0"
						}
					},
					{
						name: "Column",
						key: "column",
						component: "EditorColumn",
						icon: "mdi-table-column",
						start: false,
						accepts: ["row", "card", "text", "button", "html", "hr"],
						elements: [],
						attrs: {
							height: "",
							imgUrl: "",
							class: "pa-4",
							padding: "pa-4",
							sm: 0, 
							md: 0, 
							xs: 0,
							lg: 0,
							cols: 12
							
						}
					},
					{
						name: "HTML",
						key: "html",
						component: "EditorHtml",
						icon: "mdi-code-tags",
						start: true,
						attrs: {},
						accepts: [],
						elements: [],
					},
					{
						name: "Hr",
						key: "hr",
						component: "EditorHr",
						icon: "mdi-minus",
						start: false,
						attrs: {
							class: "",
							padding: "pa-0",
							margin: "ma-0"
						},
						accepts: [],
						elements: [],
					},
					{
						name: "Text",
						key: "text",
						component: "EditorText",
						start: true,
						icon: "mdi-format-color-text",
						accepts: ["button", "text", "html", "hr"],
						text: "",
						elements: [],
						attrs: {
							colors: {
								text: "black",
							},
							typography: {
								text: "text"
							},
							alignment: {
								text: "text-left"
							},
							padding: "pa-4",
							margin: "ma-0", 
							textClass: "text",

						}
					},
					{
						name: "Button",
						start: false,
						key: "button",
						component: "EditorButton",
						icon: "mdi-cursor-default-click",
						accepts: [],
						elements: [],
						text: "",
						link: "",
						buttonIcon: "",
						attrs: {
							colors: {
								background: "primary",
							},
							padding: "pa-4",
							margin: "ma-0",
							dark: false,
							text: false, 
							size: "default"
						}
					}
				],
				html: ""
			}
		}, 
		computed:{
			...Vuex.mapState({
				colors: state => state.settings.colors
			}),
			allowedElements(){
				var self = this;
				if( !self.focus ){
					return self.allElements.filter( e => e.start );
				}
				var element = self.allElements.find( a => a.key == self.focus.key )
				return self.allElements.filter( e => element.accepts.indexOf( e.key ) > -1);
			},
		},
		watch: {
			elements(){
				this.$emit("changed", this.elements);
			}
		},
		components: {
			EditorElement:  () => import("../edits/TextEditor/EditorElement"),
			DisplayEditorPost:  () => import("../edits/TextEditor/DisplayEditorPost"),
		},
		methods: {
			newElement(item){
				var element = {}
				element.id =  `${item.key}_${this.elements.length}`
				element.key = item.key;
				element.accepts = item.accepts;
				element.component = item.component;
				element.attrs = {...item.attrs};
				if( item.attrs.alignment ){
					element.attrs.alignment = {...item.attrs.alignment} 
				}
				else{
					delete element.attrs.alignment
				}
				if( item.attrs.typography ){
					element.attrs.typography = {...item.attrs.typography} 
				}
				else{
					delete element.attrs.typography
				}
				if( item.attrs.colors ){
					element.attrs.colors = {...item.attrs.colors} 
				}
				else{
					delete element.attrs.colors
				}
				element.elements = [];
				if( !this.focus ){
					this.elements.push(element)
				}
				else{
					element.id = this.focus.id + "_" + this.focus.elements.length + 1;
					this.focus.elements.push(element)
				}
				this.menu = false;
				// this.focus = this.elements[this.elements.length - 1]
			},
			deleteElement(element ){
				this.elements.splice( this.elements.indexOf(element), 1 )
				this.focus = false;
								
			}
		}
	}
</script>